// extracted by mini-css-extract-plugin
export default {"typeContainer":"collection_typeContainer__i-olH","headline":"collection_headline__NFoCa","column":"collection_column__uGf9K"};